export const Blogs = [
    // {
    //     name: "LeetCode Coding Profile",
    //     tags: [],
    //     date: "",
    //     imgSrc: "https://leetcard.jacoblin.cool/pratikk5?theme=dark&font=Marcellus&ext=contest",
    //     link: "https://leetcode.com/u/pratikk5/"
    // },

    {
        name: "Microsoft & LinkedIn — GenAI Productivity",
        tags: ["Microsoft", "LinkedInLearning", "GenAI", "AIProductivity", "PromptEngineering", "Copilot"],
        // date: "28 Nov 2025",
        imgSrc: "https://i.pinimg.com/736x/52/a6/96/52a6963c209092dcdf73762584c89a33.jpg",
        link: "https://www.linkedin.com/learning/certificates/02141698e92541818257897cf5869642dfd2ff000671befeae3d2294b2aa224c"
    }
    ,
    {
        name: "Google GSA — Gemini Write-off",
        tags: ["Google", "Gemini", "GSA", "CreativeWriting", "Leadership", "StudentAmbassador"],
        // date: "22 Nov 2025",
        imgSrc: "https://i.pinimg.com/736x/bd/57/65/bd5765224e576e0952812488c12db228.jpg",
        link: "https://drive.google.com/file/d/1xVegMhduc5b4O6QB8ve3ss2Tf-88oM9G/view?usp=sharing"
    },
    {
        name: "Naan Mudhalvan — Industrial IoT & 4.0",
        tags: ["NaanMudhalvan", "IndustrialIoT", "Industry4.0", "Unity", "Wokwi", "ThingSpeak", "Convai"],
        // date: "17 Nov 2025",
        imgSrc: "https://i.pinimg.com/736x/d8/f0/7e/d8f07e5370ebccdb3b94456d479245f8.jpg",
        link: "https://drive.google.com/file/d/1Pm4Hch-AXfXRnmcsMmURln47WLbagGtR/view?usp=sharing"
    },
    {
        name: "Naan Mudhalvan — EPBL Data Science",
        tags: ["NaanMudhalvan", "EPBL", "DataScience", "GoogleColab", "MachineLearning", "OCI"],
        // date: "10 Oct 2025",
        imgSrc: "https://i.pinimg.com/736x/22/bf/a3/22bfa306e56b7b310ca5a92159743b45.jpg",
        link: "https://drive.google.com/file/d/1W0z3xE2BAPzoRDZ_yyJ_AcTXcPtfwovR/view?usp=sharing"
    },
    {
        name: "OCI Certified Generative AI Professional",
        tags: ["Oracle", "OCI", "GenerativeAI", "CloudAI", "LLM", "Certification"],
        // date: "19 Aug 2025",
        imgSrc: "https://i.pinimg.com/736x/f6/aa/aa/f6aaaa52af970ceb431e8d6494f853ed.jpg",
        link: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=19A3544E1E52C0B12623FB45E727F7ECACB95FEEE7F4529B4561F653F92C9CD9"
    },
    {
        name: "Terminal, Bash & Vim Essentials",
        tags: ["Linux", "Terminal", "Bash", "Vim", "ShellScripting", "DevTools"],
        // date: "30 July 2025",
        imgSrc: "https://i.pinimg.com/736x/66/84/cf/6684cfbf6ab98c128beac6a5c57b6466.jpg",
        link: "https://drive.google.com/file/d/1nuL_7Rn0GLdm1ZxuYbBTTDHGtm9c9qRi/view?usp=sharing"
    },
    {
        name: "Adobe India Hackathon — Round 1",
        tags: ["Adobe", "Hackathon", "Coding", "ProblemSolving", "MCQ", "Innovation"],
        // date: "11 July 2025",
        imgSrc: "https://i.pinimg.com/474x/59/f1/79/59f1798ae1672c8b060e74efffa98aca.jpg",
        link: "https://drive.google.com/file/d/12fb1xpXud-o9NPykXkZ_wPVCZdN1sn4n/view?usp=drive_link"
    },

    {
        name: "Coursera — Machine Learning",
        tags: ["Coursera", "MachineLearning", "ScikitLearn", "NumPy", "SupervisedML", "AI"],
        // date: "07 July 2025",
        imgSrc: "https://i.pinimg.com/736x/48/1c/19/481c1946aed0f2b103e0550838f19888.jpg",
        link: "https://coursera.org/share/ee299c5ae6884a037017ac278dd4465c"
    },
    {
        name: "Coursera — Unsupervised & Reinforcement Learning",
        tags: ["Coursera", "UnsupervisedLearning", "ReinforcementLearning", "Clustering", "Python", "AI"],
        // date: "07 July 2025",
        imgSrc: "https://i.pinimg.com/736x/ea/c8/47/eac847423784ba4c8dad517fc521ae26.jpg",
        link: "https://coursera.org/share/0486b985e977c91e432a9a91445aa449"
    },
    {
        name: "Coursera — Advanced Learning Algorithms",
        tags: ["Coursera", "DeepLearning", "NeuralNetworks", "DecisionTrees", "TensorFlow", "DataEthics"],
        // date: "01 July 2025",
        imgSrc: "https://i.pinimg.com/736x/53/bb/e5/53bbe5c66c1d469fcc88a03e5d4fb7b6.jpg",
        link: "https://coursera.org/share/66b0236f57d8a546de6b51ebdda94e60"
    },
    {
        name: "AWS Summit India — Online",
        tags: ["AWS", "CloudComputing", "AmazonSageMaker", "AmazonQ", "Serverless", "Summit"],
        // date: "26 June 2025",
        imgSrc: "https://i.pinimg.com/736x/4b/26/0f/4b260f13bb5be323f3f545a39b45845c.jpg",
        link: "https://drive.google.com/file/d/1SWEnVrFIt7dd2bP4rio2o5T4U6FuV7nr/view?usp=sharing"
    },
    {
        name: "Coursera — Supervised Machine Learning",
        tags: ["Coursera", "SupervisedLearning", "Python", "Regression", "Classification", "AI"],
        // date: "25 June 2025",
        imgSrc: "https://i.pinimg.com/736x/32/41/0d/32410de19565b06284435e21f97c7dec.jpg",
        link: "https://coursera.org/share/441b7be0a6db93289760730df7993ac7"
    },
    {
        name: "Udemy — Python Bootcamp 2025",
        tags: ["Udemy", "Python", "OOP", "Scripting", "Projects", "Certification"],
        // date: "07 June 2025",
        imgSrc: "https://udemy-certificate.s3.amazonaws.com/image/UC-5ed3b56a-478e-4044-b319-d5fbfebf9f89.jpg?v=1749307223000",
        link: "https://www.udemy.com/certificate/UC-5ed3b56a-478e-4044-b319-d5fbfebf9f89/"
    },
    {
        name: "OCI Certified AI Foundations Associate",
        tags: ["Oracle", "OCI", "AIFoundations", "CloudAI", "MLBasics", "Certification"],
        // date: "09 May 2025",
        imgSrc: "https://i.pinimg.com/736x/6e/3d/c2/6e3dc274f3be37c40b3743dbf0840945.jpg",
        link: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=57190B390DA0899441C290B7E3AC92BA574EA590269F7694F3061F6CED2AE88D"
    },
    {
        name: "Thoothukudi Police Hackathon 2025",
        tags: ["Hackathon", "PublicSafety", "AI", "Innovation", "ProblemSolving", "2025"],
        // date: "8 April 2025",
        imgSrc: "https://i.pinimg.com/736x/39/53/40/395340f1b839491ff471ce4574023abf.jpg",
        link: "https://drive.google.com/file/d/1TnusO_UYFrKFNARFx6I-W1l7y2nayJXB/view?usp=sharing"
    },
    {
        name: "OCI Certified Cloud Foundations Associate",
        tags: ["Oracle", "OCI", "CloudFoundations", "Networking", "Compute", "Certification"],
        // date: "19 April 2025",
        imgSrc: "https://i.pinimg.com/736x/95/1f/8a/951f8afdb16d5f4b7495b339127b73b4.jpg",
        link: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=1D180CA5A75214F6C0F47918C3C05957F639C44E90F5C6211F1F6BFA153DC5C2"
    },
    // {
    //     name: "Codequezt # 18 - Coding Challenge",
    //     tags: ["coding", "problem solving"],
    //     date: "06 April 2025",
    //     imgSrc: "https://media.naukri.com/media/nccontcert/l444%253ALuAMAkberXd6ftfGICBJaJg0wHUmI809h195md42tjEzVMF8k1%252FiRUY1yp7h71PuAp0%253D",
    //     link: "https://www.naukri.com/campus/certificates/participation/v0/67f76df0892c1f3133aac135?utm_source=certificate&utm_medium=copy&utm_campaign=67f76df0892c1f3133aac135"
    // },
    {
        name: "Git & GitHub — Amigoscode",
        tags: ["Git", "GitHub", "VersionControl", "Branching", "Collaboration", "Amigoscode"],
        // date: "21 March 2025",
        imgSrc: "https://i.pinimg.com/736x/70/6b/59/706b59f6d55cebaadde6c4f7d457e9dc.jpg",
        link: "https://www.amigoscode.com/certificates/d6df5cec-05ec-48a7-9d79-97f39670819a"
    },
    // {
    //     name: "Ultimate Cyber Security Beginner Course : Zero to Hero",
    //     tags: ["CyberSecurity", "TutorialsPoint"],
    //     date: "14 March 2025",
    //     imgSrc: "https://d3mxt5v3yxgcsr.cloudfront.net/certificates/TP-GQV6L6SN.jpg?v=1741954966",
    //     link: "https://www.tutorialspoint.com/market/certificate.jsp/TP-GQV6L6SN?v=1741954962"
    // },
    // {
    //     name: "Brandquezt # 17 - Brand Ambassadors and Influencers",
    //     tags: ["BrandContest", "BrandAmbassadors"],
    //     date: "25 Feb 2025",
    //     imgSrc: "https://media.naukri.com/media/nccontcert/l444%253ALuAMAkberXd6ftfGICBJYJ01xH1sbss%252Bg19yk9kzsHQC8jzrDhre8yc0T0J3VGx6MQ%253D%253D",
    //     link: "https://www.naukri.com/campus/certificates/participation/v0/67bd7b0c892c1f3133aaab34"
    // },
    // {
    //     name: "Bizquezt # 17 - Economic Theories ",
    //     tags: ["BizQuezt", "Economics", "Naukri", "Economic Theories"],
    //     date: "16 Feb 2025",
    //     imgSrc: "https://media.naukri.com/media/nccontcert/l444%253ALuAMAkberXd6ftfGICBJYJ03w31sbss%252Bg1p%252Fl9Ezt3QCIhCGA5jD2td7TrgPFVNpXw%253D%253D",
    //     link: "https://www.naukri.com/campus/certificates/participation/v0/67b846866c1aa41e163b352c?utm_source=certificate&utm_medium=copy&utm_campaign=67b846866c1aa41e163b352c"
    // },
    // {
    //     name: "Techquezt #16-CyberSecurity Contest",
    //     tags: ["CyberSecurity", "TechContest", "Techquezt"],
    //     date: "02 Feb 2025",
    //     imgSrc: "https://media.naukri.com/media/nccontcert/l444%253ALuAMAkberXd6ftfGICBJYZ8zwHxsbss5ilt7ldk4t3QCUjmt7JcnB8NP7v%252BoFpJK%252Bw%253D%253D",
    //     link: "https://www.naukri.com/campus/certificates/participation/v0/67a5ee11126ac74cafaf272e?utm_source=certificate&utm_medium=copy&utm_campaign=67a5ee11126ac74cafaf272e"
    // },
    {
        name: "Accenture Nordics — Technology Program",
        tags: ["Accenture", "SoftwareArchitecture", "Testing", "Security", "Agile", "Consulting"],
        // date: "Jan 2025",
        imgSrc: "https://i.pinimg.com/736x/00/7e/8f/007e8fbce8c5015b8c869cb3b65cb21d.jpg",
        link: "https://drive.google.com/file/d/197uuPttZTdY9MY8wTkX9wijWUBemIagk/view?usp=sharing"
    },
    // {
    //     name: "Certificate of merit in Young Turks Skill Contest",
    //     tags: ["aptitude", "naukri", "Young turks skill contest"],
    //     date: "11 th October 2024",
    //     imgSrc: "https://media.naukri.com/media/nccontcert/l444%253ALuAMAkberXd6ftfGICBJbZ4zx31sbss4i11yldEytnQCz%252BFwsiOFJY0mkCEKoaWnqg%253D%253D",
    //     link: "https://www.naukri.com/campus/certificates/young_turks_round_1_achievement/v0/6707fced5abe131f423e7363?utm_source=certificate&utm_medium=copy&utm_campaign=6707fced5abe131f423e7363"
    // }
];
